import loadable from '@wix/yoshi-flow-editor/loadable';

export const DiscussionPage = loadable(
  () => import(/* webpackChunkName: "DiscussionPage" */ './DiscussionPage'),
  {
    resolveComponent: (component) => component.DiscussionPage,
  },
);
